import Biotech from "@mui/icons-material/Biotech";
import CheckCircle from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled, { css } from "styled-components";
import { HXButton } from "./HXButton";
import { HXPage, HXPageSubtabs } from "./HXDesktopPage";
import Cancel from "@mui/icons-material/Cancel";
import PauseCircle from "@mui/icons-material/PauseCircle";
import NotStarted from "@mui/icons-material/NotStarted";
import AvatarGroup from "@mui/material/AvatarGroup";
import Chip from "@mui/material/Chip";
export const StudyManagerViewParent = styled(HXPage) ``;
export const NotFound = styled.div `
    margin-top: 40px;
    font-size: ${fontSizes.MEDIUM};
`;
export const DeleteButton = styled(HXButton) `
    color: ${colors.tulip_main};
    border-color: ${colors.tulip_main};
`;
export const DeleteStudyIcon = styled(DeleteIcon) `
    &&& {
        color: ${colors.tulip_main};
    }
`;
const ActionIconCommonCSS = css `
    width: 24px;
    height: 24px;
`;
export const MarkAsExecutingIcon = styled(Biotech) `
    &&& {
        color: ${colors.navy_main};
        ${ActionIconCommonCSS}
    }
`;
export const CompleteIcon = styled(CheckCircle) `
    &&& {
        color: ${colors.forest_main};
        ${ActionIconCommonCSS}
    }
`;
export const WithdrawIcon = styled(Cancel) `
    &&& {
        color: ${colors.tulip_main};
        ${ActionIconCommonCSS}
    }
`;
export const PauseStudyIcon = styled(PauseCircle) `
    &&& {
        color: ${colors.navy_main};
        ${ActionIconCommonCSS}
    }
`;
export const ResumeStudyIcon = styled(NotStarted) `
    &&& {
        color: ${colors.navy_main};
        ${ActionIconCommonCSS}
    }
`;
export const StudyStatusChipParent = styled(Chip) `
    background-color: ${({ hxcolor }) => hxcolor};
    font-size: ${fontSizes.SMALL};
`;
export const TeamAvatars = styled(AvatarGroup) `
    cursor: pointer;
    & .MuiAvatar-root {
        width: 32px;
        height: 32px;
        font-size: 14px;
    }
`;
export const MoreUsersView = styled.div ``;
export const StudyManagerSubtabs = styled(HXPageSubtabs) `
    background-color: ${colors.white_main};
    // "cheat" the container bigger so it covers the margins too
    padding: 0px 80px;
    margin: 0 -80px;
`;
